<template>
  <div class="iframe">
    <iframe
      :src="node.attrs.src"
      width="560"
      height="315"
      frameborder="0"
      allowfullscreen
      class="iframe__embed"
    ></iframe>
  </div>
</template>

<script>
export default {
  name: 'IFrameNode',
  props: { node: { type: Object, required: true } },
}
</script>
